module.exports = __webpack_public_path__ + "img/logo.a6ed4652.svg";